<template>
  <div style="height:100%;display:flex;" class="u-flex-column">
    <div style="height:160px;padding-left:160px">
      <el-form
        :size="'small'"
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item label="统计时间">
          <el-date-picker
            style="width: 330px"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="time"
            type="daterange"
            :picker-options="pickerOptions"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00','23:59:59']"
            :clearable="false"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getdata">统计</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="u-text-center" style="font-size:0.22rem;color:#fff">
      {{ barData.name }}统计
    </div>
    <div style="flex:1;min-height:0">
      <bar-echart :chart-data="barData" :key="eckey"></bar-echart>
    </div>
    <div style="height:220px;padding:12px 40px 20px">
      <statistic-detail-table :dates="tableDates" :rows="tableRows" />
    </div>
  </div>
</template>

<script>
// 导入组件
import BarEchart from "@/components/echarts/barEchart.vue";
import StatisticDetailTable from "@/components/echarts/StatisticDetailTable.vue";
import { setTime } from "@/commons/util.js";
import { createStatisticTableRows } from "./statisticTable";
export default {
  data() {
    return {
      eckey:'',
      tableDates: [],
      tableRows: [],
      personCategoryOptions: [
        { label: '\u4e34\u65f6\u4eba\u5458', value: 2 }
      ],
      barData: {
        name: "临时人员",
        /* data: [
          120,
          200,
          150,
          80,
          70,
          110,
          130,
          120,
          200,
          150,
          80,
          70,
          110,
          130,
          130
        ],
        xvalue: [
          "2021-01-02",
          "2021-01-03",
          "2021-01-04",
          "2021-01-05",
          "2021-01-06",
          "2021-01-07",
          "2021-01-08",
          "2021-01-09",
          "2021-01-10",
          "2021-01-11",
          "2021-01-12",
          "2021-01-13",
          "2021-01-14",
          "2021-01-15"
        ] */
      },
      formInline: {},
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      time: setTime(15)
    };
  },
  components: {
    BarEchart,
    StatisticDetailTable
  },
  methods: {
    getdata() {
      const data = {
        beginTime:this.time[0],
        endTime:this.time[1],
        pageIndex:1,
        pageRow:100,
        personType:2
      };
      this.$http.POST_statisticByFacePassType(data).then(res => {
        const dates = res.data.statisticKey || [];
        //console.log('统计结果',res);
        this.$set(this.barData,'data',res.data.statisticValue);
        this.$set(this.barData,'xvalue',dates);
        this.tableDates = dates;
        this.tableRows = createStatisticTableRows(dates, this.personCategoryOptions, [res]);
        this.eckey=new Date().getTime();
      });
    }
  },
  mounted() {
    this.getdata()
  }
};
</script>

<style lang="scss">
input::-webkit-input-placeholder {
  font-size: 14px;
}
.el-form-item__label {
  font-size: 14px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/tjfx/lsrytj.vue